import React from 'react';

import { ModalLayout } from '@/features/modal/modals/ModalLayout';
import LegalCmsContent from '@/components/shared/LegalCmsContent';
import { useTermsAndConditionsLoader } from '@/hooks/useTermsAndConditionsLoader';
import { BaseModalProps } from '@/features/modal/types';

export const TermsAndConditionsModal = ({ closeModal }: BaseModalProps) => {
  const { tcData, tcLoading } = useTermsAndConditionsLoader();

  return (
    <ModalLayout close={closeModal}>
      <LegalCmsContent data={tcData} loading={tcLoading} />
    </ModalLayout>
  );
};
